import React from "react";

export function waitUntilDefined(val:()=>any): Promise<void> {
  return new Promise<void>((resolve) => {
    function checkValue() {
      if (val() !== undefined) {
        console.debug("Value loaded : ", val())
        resolve();
      } else {
        setTimeout(checkValue, 100);
      }
    }
    checkValue();
  });
}
